import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AppConfigService } from '../../services/app-config.service';
import { AttachmentService } from '../../shared/services/attachment.service';

@Component({
  selector: 'app-upload-files',
  templateUrl: './app-upload-files.component.html'
})
export class AppUploadFilesComponent{

  form: FormGroup;
  loading = false;
  public metaData: any = [];
  public datas: any = [];
  public listFiles: any = [];
  public idCerfa;
  public toastrUpload: ToastsManager;
  /** Identifiant de rubrique pour filtrer les PJ affichées ('B', 'C', 'D', 'H'). Si null/undefined, affiche toutes les PJ. */
  public rubrique: string;

  private fileObject;
  private fileType: string;
  private fileSize: number;

  public readonly MAX_FILE_SIZE = 20000000;

  private alive = true;

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    private fb: FormBuilder,
    private _attachmentService: AttachmentService,
    // @Inject(forwardRef(() => FormDiaComponent)) private _parent: FormDiaComponent
  ) {
    this.createForm();
    this._attachmentService.listPiecesJointes$.subscribe((listPiecesJointes: string[]) => {
      this.listFiles = listPiecesJointes || [];
    });
  }

  createForm() {
    this.form = this.fb.group({
      idCerfa: ['', Validators.required],
      file: null
    });
  }

  onFileChange(event) {
    if(event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.get('file').setValue(file);
    }
  }

  /**
   * Supprime un fichier grace à son id (fonction appelée sur les bouton supprimer dans les listes de fichiers)
   *
   * @param idFile
   */
  deleteFile(idFile): void {
    this._attachmentService.deleteFiles(idFile, this.idCerfa).takeWhile(() => this.alive).subscribe(
      result => {
        this.getListFiles();
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Renvoit la liste des fichiers lié au formulaire courant
   */
  getListFiles(): void {
    this._attachmentService.getFiles(this.idCerfa).takeWhile(() => this.alive).subscribe(
      result => {
        console.log(result);
        this._attachmentService.setListPiecesJointes(result);
      },
      error => { this.metaData = <any>error }
    );
  }

  private prepareSave(): any {
    const fileObject = this.form.get('file').value;

    this.fileType = fileObject.type;
    this.fileSize = fileObject.size;

    return fileObject;
  }

  onSubmit() {
    this.fileObject = this.prepareSave();
    this.loading = true;

    if (this.fileType === 'application/pdf' && this.fileSize <= this.MAX_FILE_SIZE) {
      this._attachmentService.sendFile(this.fileObject, this.idCerfa, this.rubrique).takeWhile(() => this.alive).subscribe(
        result => {
          if(result) {
            this.datas = result;
            this._attachmentService.getFiles(this.idCerfa).subscribe((listPiecesJointes: string[]) => {
              this._attachmentService.setListPiecesJointes(listPiecesJointes);
            });
          } else {
            this.sendToastRError('L\'upload du fichier a échoué.', 'Merci de réessayer');
          }

          this.loading = false;
        },
        error => { this.metaData = <any>error }
      );
    } else {
      if (this.fileType !== 'application/pdf') {
        this.sendToastRError('Seul les documents pdf sont accepté.', 'Mauvais type de fichier');
      }
      if (this.fileSize > this.MAX_FILE_SIZE) {
        this.sendToastRError('La taille de la pièce jointe de doit pas excéder 20mo.', 'Taille de fichier trop importante');
      }
      this.loading = false;
    }
  }

  /**
   * Envoi d'un message d'erreur ToastR
   * @param message message d'erreur
   * @param cause la cause
   */
  private sendToastRError(message: string, cause: string) {
    this.toastrUpload.error(message, cause).then((toast: Toast) => {
      setTimeout(() => {
        this.toastrUpload.dismissToast(toast);
      }, AppConfigService.settings.toastRMessagesDismissTime);
    });
  }

  clearFile() {
    this.form.get('file').setValue(null);
    this.fileInput.nativeElement.value = '';
  }

  /**
   * Retourne le nom de fichier sans le préfixe de rubrique [X] pour l'affichage
   */
  getDisplayFilename(filename: string): string {
    if (filename && filename.match(/^\[.+?\]/)) {
      return filename.replace(/^\[.+?\]/, '');
    }
    return filename;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-upload-files/app-upload-files.component.ts